
const GetForeStreetKpiReducer = (state = { type: 'LOADING_FORESTREET_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_FORESTREET_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetForeStreetMainReducer = (state = { type: 'LOADING_FORESTREET_CARD_ACTION', data: {} }, action) => {
    
    switch (action.type) {
        case 'SUCCESS_FORESTREET_CARD_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetForeStreetKpiReducer,
    GetForeStreetMainReducer
}